import { createContext } from 'react'

export const TokenContext = createContext<string | undefined>(undefined)

/**
 * True below `SharedBuyLayout`, which wraps every checkout route including the empty-cart recovery
 * page. Lets shared components tell that they are on a checkout surface, where the cart is already
 * on screen and the global header - and with it the mini cart - is not rendered.
 */
export const InCheckoutContext = createContext(false)

/**
 * Which checkout surface renders below the cart-loading swap. `CheckoutSkeleton` reads it so it
 * prefigures the chrome that page actually renders: a placeholder for chrome the page omits
 * collapses the moment the cart resolves, and chrome the page adds pushes the column down.
 *
 * - `step` owns a `CheckoutLayout`: logo, a form, a fixed step footer.
 * - `confirmation` renders no `CheckoutLayout` at all. It heads its own column with a ruled logo
 *   header and ends it with its own footer bar, and has no form - so a step skeleton there drops
 *   four fields and a button on the shopper and takes them all back again.
 *
 * A context rather than a prop because two skeletons render per checkout page - `SharedBuyLayout`'s
 * own loading branch and `NonEmptyCartContextProvider`'s - and threading the value to both from the
 * page would leave one of them to be forgotten.
 */
export type CheckoutSurface = 'step' | 'confirmation'

export const CheckoutSurfaceContext = createContext<CheckoutSurface>('step')

export const HubSpotContext = createContext<{
  trackEvent(event: { id: string; value: number }): void
}>({
  trackEvent() {
    console.warn('HubSpot context not initialized')
  },
})
